import React from "react";

const baseProps = {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.8,
    stroke: "currentColor",
};

export function MenuIcon(props) {
    return (
        <svg {...baseProps} {...props}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 7h16M4 12h16M4 17h16" />
        </svg>
    );
}

export function CloseIcon(props) {
    return (
        <svg {...baseProps} {...props}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 6l12 12M18 6l-12 12" />
        </svg>
    );
}
